export default __webpack_public_path__ + "static/media/unnamed.c5eb3645.jpg";